import React from "react";

export const State = React.createContext();
